import React from 'react';
import { formatNumber, isRateField } from '../../../../../../utils/UtilReport';
import PropTypes from 'prop-types';

export const CustomFooterCellDimensions = ({ props, filterDimensions, filterProperties }) => {
     if (props.ariaColumnIndex === filterDimensions.length + filterProperties.length) {
          return (
               <>
                    <td
                         className={props.className}
                         style={{
                              ...props.style,
                              textAlign: 'right',
                              borderLeft: 'none',
                         }}
                    >
                         Totals
                    </td>
               </>
          );
     } else {
          return <td className={props.className} style={{ ...props.style, borderLeft: 'none' }}></td>;
     }
};

export const CustomFooterCellProperties = ({ props, filterDimensions, filterProperties }) => {
     if (props.ariaColumnIndex === filterProperties.length + filterDimensions.length) {
          return (
               <td className={props.className} style={{ ...props.style, textAlign: 'right', borderLeft: 'none' }}>
                    Totals
               </td>
          );
     } else {
          return <td className={props.className} style={{ ...props.style, borderLeft: 'none' }}></td>;
     }
};

const getTotalCell = (field, reportData) => {
     if (reportData.totalsRow?.length > 0) {
          const totalCell = reportData.totalsRow[0].metricCompoundValues.find((item) => item.key === field) || {};
          const parsedValue = isFinite(totalCell.value) ? Number(totalCell.value) : totalCell.value;
          const value = totalCell?.value ? parsedValue : 0;

          if (totalCell) {
               if (typeof totalCell.value !== 'number' && !isFinite(totalCell.value)) {
                    return totalCell.value;
               } else if (isRateField({ value: field })) {
                    return `${formatNumber(Number(totalCell.value))}%`;
               } else {
                    return formatNumber(value);
               }
          }
     }
};

export const CustomFooterCellDefault = ({ props, reportData }) => {
     const totalCell = getTotalCell(props.field, reportData);
     return (
          <td className={props.className} style={props.style} width={props.width}>
               {totalCell || totalCell === 0 ? totalCell : ''}
          </td>
     );
};

CustomFooterCellDefault.propTypes = {
     reportData: PropTypes.array,
     props: PropTypes.any,
     field: PropTypes.any,
     width: PropTypes.number,
     className: PropTypes.string,
     style: PropTypes.any,
};

CustomFooterCellProperties.propTypes = {
     props: PropTypes.any,
     filterProperties: PropTypes.array,
     filterDimensions: PropTypes.array,
     ariaColumnIndex: PropTypes.number,
     className: PropTypes.string,
     style: PropTypes.any,
};

CustomFooterCellDimensions.propTypes = {
     props: PropTypes.any,
     filterDimensions: PropTypes.array,
     filterProperties: PropTypes.array,
     ariaColumnIndex: PropTypes.number,
     className: PropTypes.string,
     style: PropTypes.any,
};
